import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiService} from "./api.service";
import {LocalStorageService} from "./local-storage.service";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

const SERVER_URL = environment.api_url;
const IS_LIVE_MODE = environment.is_live_mode;

@Injectable({
    providedIn: 'root'
})
export class ReportedTaxReportService extends ApiService {

    constructor(
        public http: HttpClient,
        public storageBrowser: LocalStorageService,
    ) {
        super(http, storageBrowser);
    }

    createReportedTaxReport(data: any, replace = false): Observable<any> {
        const token = this.storageBrowser.get('token');

        if (this.storageBrowser.get('mode') === null) {
            this.storageBrowser.set('mode', IS_LIVE_MODE);
        }

        let is_liveMOde = (this.storageBrowser.get('mode') === null) ? IS_LIVE_MODE : this.storageBrowser.get('mode');

        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'islive': `${is_liveMOde}`
        });

        const url = `${SERVER_URL}reported-tax-reports${replace ? '/replace' : ''}`;

        const {type, partnerId, customerId, reportMonth, reportYear, isQuarterly, reportQuarter, countryCode, file} = data;
        const formData = new FormData();
        formData.append('type', type);
        formData.append('partnerId', partnerId);
        formData.append('customerId', customerId);
        formData.append('reportMonth', reportMonth);
        formData.append('reportYear', reportYear);
        formData.append('isQuarterly', isQuarterly);
        formData.append('reportQuarter', reportQuarter);
        formData.append('countryCode', countryCode);
        formData.append('file', file);
        return this.http.post(url, formData, {headers});
    }
}
